import { Dossier } from 'src/types'

export const mapDossier: (dossier: Dossier) => Dossier = (dossier: Dossier) => {
  const mappedDossier = {
    ...dossier,
    assicurato: dossier.assicurato
      ? {
          ...dossier.assicurato,
          idAssicurato: dossier.assicurato.associatoId
            ? dossier.assicurato.associatoId
            : dossier.assicurato.idAssicurato,
        }
      : undefined,
  }

  delete mappedDossier.assicurato?.associatoId

  return mappedDossier
}
